// @flow

import React, { Component } from 'react'
import { Layout, ImageHeader, Caption, BodyTitle, Logo } from './Sections'
import styled, { ReactComponentStyled } from 'styled-components'

const Container: ReactComponentStyled<{}> = styled.div`
  text-align: center;
`
const IFrameContainer: ReactComponentStyled<{}> = styled.div`
  padding-left: 25px;
  padding-right: 25px;
  width: 100%;
  height: 100%;
  display: inline;
  @media only screen and (max-width: 700px) {
    padding-left: 0%;
    padding-right: 0%;
  }
`
const FrameView = styled.iframe`
  width: 100%;
  padding: 8px 24px;
  height: 100vh;
 
`

type IFrameContentProps = {
  title: string,
  logoUrl: string,
  caption: ?string,
  url: string,
  thumbnail: ?string
}

class IFrameContent extends Component <IFrameContentProps, {}> {
  getHeader () {
    const { thumbnail } = this.props
    if (thumbnail) {
      return <ImageHeader src={thumbnail} sideNav />
    }

    return null
  }

  getBody () {
    const { logoUrl } = this.props
    const title = this.getBodyTitle()
    const caption = this.getCaption()
    const iframe = this.getIFrameContainer()
    return (
      <div>
        <Logo src={logoUrl} />
        {title}
        {caption}
        <div id='TESTTTTT' style={{ height: '100%' }}>
          {iframe}
        </div>

      </div>
    )
  }

  getCaption () {
    const { caption, logoUrl } = this.props
    if (!caption) {
      return null
    }
    return <Caption usePadding={!logoUrl} caption={caption} />
  }

  getBodyTitle () {
    const { title } = this.props
    return <BodyTitle title={title} usePadding={false} />
  }

  getIFrameContainer () {
    const { url } = this.props
    return (
      <Container>
        <IFrameContainer>
          <FrameView src={url} />
        </IFrameContainer>
      </Container>
    )
  }

  render () {
    const { logoUrl } = this.props
    const header = this.getHeader()
    const body = this.getBody()
    return (
      <Layout header={header} body={body} usePadding={!logoUrl} useParallax={header} />
    )
  }
}

export default IFrameContent
